import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { VehicleType } from '@/types/vehicle-type'

export function getVehicleTypes(): Promise<AxiosResponse<VehicleType[]>> {
  return instance.get(`/vehicle-type`)
}
